<svg>
  <use attr.xlink:href="#{{icon}}"></use>
</svg>
